<template>
  <div v-if="player">
    <!-- fields -->
    <!-- if locked -->
    <div v-if="player.isLocked" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label player-is-locked">{{"player.general.locked until" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">{{player.lockoutEndDate | datetime}}</span>
          </p>
        </div>
      </div>
    </div>
    <div v-if="player.lockReason" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label player-is-locked">{{"player.general.lock reason" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">{{player.lockReason}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
              <a v-if="player.isLocked" class="button" @click="unlockPlayer()">{{"player.general.unlock" | translate}}</a>
              <a v-else class="button is-warning" @click="lockPlayer()">{{"player.general.lock" | translate}}</a>
          </p>
        </div>
      </div>
    </div>
    <!-- username -->
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.login" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">{{player.username}}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- registration type -->
    <div v-if="player.registrationInfo && player.registrationInfo.type" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.registration type" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.registrationInfo.type}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- alias -->
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.alias" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.alias}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- email -->
    <div v-if="player.email" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.email" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.email}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- phone number -->
    <div v-if="player.phoneNumber" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.phone number" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.phoneNumber}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- messenger -->
    <div v-if="player.phoneNumber" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.messanger" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.messenger}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- first middle last name -->
    <div v-if="player.firstName || player.middleName || player.lastName" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.name" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.firstName}} {{player.middleName}} {{player.lastName}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- date of birth -->
    <div v-if="player.dateOfBirth" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.date of birth" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.dateOfBirth | date}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- passport -->
    <div v-if="player.passport" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.passport" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.passport}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- post address -->
    <div v-if="player.address" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.post address" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.address}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- IP -->
    <div v-if="player.registrationInfo && player.registrationInfo.ip" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.ip" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.registrationInfo.ip}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- UserAgent -->
    <div v-if="player.registrationInfo && player.registrationInfo.userAgent" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"player.general.useragent" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{player.registrationInfo.userAgent}}
            </span>
          </p>
        </div>
      </div>
    </div>

    <!-- balances -->
    <p class="title is-5">{{"player.general.balances" | translate}}</p>
    <table class="table is-fullwidth is-hoverable">
      <tr>
        <th>{{"player.general.currency" | translate}}</th>
        <th>{{"player.general.branch" | translate}}</th>
        <th>{{"player.general.balance" | translate}}</th>
        <th>{{"player.general.bonus" | translate}}</th>
        <th>{{"player.general.bonus playthrough" | translate}}</th>
      </tr>
      <tr v-for="balance in player.balances">
          <td>{{balance.currency}}</td>
        <td><description :obj="balance" /></td>
        <td>{{balance.real | currency(balance.currency)}}</td>
        <td>{{balance.bonus | currency(balance.currency)}}</td>
        <td>
          <template v-if="balance.bonuses && balance.bonuses.playThrough">
            {{balance.bonuses.playThrough.betProgressPercent | tofixed(2)}}%, {{balance.bonuses.playThrough.startAmount | currency(balance.currency)}}
          </template>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
  import state from '../../../../state'
  import utils from '../../../../utils'
  import playerService from '../../../../services/player.service'
  import balanceService from '../../../../services/balance.service'

  import description from '../../../common/description.vue'

  export default {
    name: 'player-general',
    components: { description },
    data() {
      return {
        player: null
      }
    },
    computed: {
      playerId() {
        return this.$route.params.playerId;
      }
    },
    async mounted() {
      await this.load();
    },
    methods: {
      async load() {
        await playerService.load(this.playerId);
        let player = utils.clone(state.editPlayer.get());
        if (player.balances.length) {
          for (var i = 0; i < player.balances.length; i++) {
            player.balances[i].bonuses = await balanceService.getBonuses(player.balances[i].id);
          }
        }
        this.player = player;
      },
      async save() {
        await playerService.save(this.player);
        await this.load();
      },
      async saveBalance(balance) {
        await balanceService.save(balance);
        await this.load();
      },
      async lockPlayer() {
        if (confirm("Are you sure you want to lock player " + this.player.username + "?")) {
          await playerService.lock(this.player.id);
          await this.load();
        }
      },
      async unlockPlayer() {
        if (confirm("Are you sure you want to unlock player " + this.player.username + "?")) {
          await playerService.unlock(this.player.id);
          await this.load();
        }
      }
    }
  }
</script>
<style scoped>
  .player-is-locked {
    color: red !important;
    font-weight: bold !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/players/player/general.vue